var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOthermedia3 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.81066V4H11V0H11.1893C11.3882 1.03999e-06 11.579 0.0790133 11.7197 0.219656L14.7803 3.28031C14.921 3.42097 15 3.61174 15 3.81066ZM10.75 5C10.3375 5 10 4.6625 10 4.25V0H1.75C1.33578 0 1 0.335781 1 0.75V15.25C1 15.6642 1.33578 16 1.75 16H14.25C14.6642 16 15 15.6642 15 15.25V5H10.75ZM5.51703 5.5C6.34547 5.5 7.01703 6.17156 7.01703 7C7.01703 7.82844 6.34547 8.5 5.51703 8.5C4.68859 8.5 4.01703 7.82844 4.01703 7C4.01703 6.17156 4.68862 5.5 5.51703 5.5ZM12.017 13H4.01703L4.03219 11.4848L5.26703 10.25C5.41347 10.1036 5.63575 10.1187 5.78219 10.2652L7.01703 11.5L10.2519 8.26516C10.3983 8.11872 10.6357 8.11872 10.7822 8.26516L12.017 9.5V13Z",
    fill: "#005E7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOthermedia3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/othermedia3.59fbcacb90fc4264959d114b13614075.svg";